import React, { FunctionComponent } from 'react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import styles from './styles.module.scss';

interface IProgressBarProps {
  value: number;
  max: number;
  className?: string;
}

const ProgressBar: FunctionComponent<IProgressBarProps> = ({ value, max, className, children }) => (
  <CircularProgressbarWithChildren
    value={value}
    maxValue={max}
    className={`${className} ${styles.progress}`}
  >
    {children}
  </CircularProgressbarWithChildren>
);

export default ProgressBar;
